import { makeAutoObservable } from 'mobx';
import { z } from 'zod';
import { StringDto } from '../../../../../../store/utils/Dto';
import extractValue, {
  type EventOrValue,
} from '../../../../../../store/utils/extractValue';
import Validator from '../../../../../../store/utils/Validator';
import { errorHandler } from '../../../../../../utils/errors';

export default class HiseLink {
  static readonly Schema = z.object({
    enabled: z.boolean(),
    company: z.string(),
    product: z.string(),
  });

  enabled = false;
  company = '';
  product = '';

  private readonly validator = new Validator(this, HiseLink.Schema);

  constructor(
    dto: HiseLinkDto | undefined,
    private readonly onSave: (hiseLink: HiseLink) => Promise<void>,
  ) {
    makeAutoObservable(this, {}, { autoBind: true });

    this.enabled = dto?.enabled || false;
    this.company = dto?.company || '';
    this.product = dto?.product || '';
  }

  get errors(): StringDto<HiseLinkDto> {
    return this.validator.errorsForEnabledFields;
  }

  handleChange(e: EventOrValue<keyof HiseLinkDto>) {
    const { name, value } = extractValue(e);
    Object.assign(this, { [name]: value });
    this.validator.validate();
    this.save();
  }

  handleBlur(e: EventOrValue<keyof HiseLinkDto>) {
    const { name } = extractValue(e);
    this.validator.enableFieldValidation(name);
  }

  save() {
    this.onSave(this).catch(errorHandler('Cannot save hise link'));
  }

  toJSON(): HiseLinkDto | undefined {
    if (!this.enabled || !this.company || !this.product) {
      return undefined;
    }

    return {
      enabled: this.enabled,
      company: this.company.trim(),
      product: this.product.trim(),
    };
  }
}

export interface HiseLinkDto {
  company?: string;
  enabled?: boolean;
  product?: string;
}
